function stripHtmlTags(str) {
  if (typeof str !== 'string') return ''
  return str.replace(/<[^>]*>/g, '')
}

function replaceMergeFields(str) {
  if (typeof str !== 'string') return ''
  // approximate merge field
  return str.replace(/\{[^}]+\}/g, 'xxxxxxxx')
}

export function getCharacterCount(content) {
  let formattedMessage = stripHtmlTags(replaceMergeFields(content))
  let totalCount = isGsm7(formattedMessage) ? 306 : 134
  return totalCount - formattedMessage.length
}

function isGsm7(message) {
  let gsm7Pattern =
    /^[\u0000-\u007F€£¥èéùìòÇØøÅåΔ_ΦΓΛΩΠΨΣΘΞÆæÉ!"#¤%&'()*+,\-./0-9:;<=>?@A-Z\[\\\]^_`a-z{|}~ \n\r]*$/
  return gsm7Pattern.test(message)
}
